import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { Nav } from "../../components/nav";
import { useLocale } from "../../stores/locale";
import { ContractList } from "./contract-list";
import { ContractSummary } from "./contract-summary";

export function Contracts() {
  const { locale: t } = useLocale();

  return (
    <>
      <Nav
        className="mb-4"
        items={[
          { title: t.contract.contracts, slug: "/admin/contract/list" },
          { title: t.contract.summaryNav, slug: "/admin/contract/summary" },
        ]}
      />

      <Routes>
        <Route index element={<Navigate replace to="list" />} />
        <Route element={<ContractList />} path="/list/*" />
        <Route element={<ContractSummary />} path="/summary" />
      </Routes>
      <Outlet />
    </>
  );
}
